import { AxiosResponse } from 'axios';
import {
  OrderProductGetDTO,
  PalletsPerStatusDto,
  PurchaseOrderProductCreateDto,
  PurchaseOrderProductGetDto,
  PurchaseOrderProductEditDto,
} from 'svila-common';
import { API_URL } from '../../utils/constants';
import request from '../request';
import { PurchaseOrderProductsResponseDto } from '~/src/types/PurchaseOrderProductsResponseDto';

export default {
  // get: async (id) => {
  //   return request(`${API_URL}/purchase-order-products/${id}`, 'get', {}, {});
  // },
  update: async (
    id: string,
    values: PurchaseOrderProductEditDto,
  ): Promise<AxiosResponse<PurchaseOrderProductGetDto>> => {
    const body = JSON.stringify(values);
    return request(`${API_URL}/purchase-order-products/${id}`, 'put', body, {});
  },
  create: async (values: PurchaseOrderProductCreateDto): Promise<AxiosResponse<PurchaseOrderProductGetDto>> => {
    const body = JSON.stringify(values);
    return request(`${API_URL}/purchase-order-products/`, 'post', body);
  },
  delete: async (id: string): Promise<AxiosResponse<PurchaseOrderProductGetDto>> => {
    return request(`${API_URL}/purchase-order-products/${id}`, 'delete');
  },
  getForOrder: async (id: string): Promise<AxiosResponse<PurchaseOrderProductsResponseDto>> => {
    return request(`${API_URL}/purchase-order-products/for-order-id/${id}`, 'get');
  },
  // getCalculatorList: async (id) => {
  //   return request(`${API_URL}/purchase-order-products/calculator/get-list/${id}`, 'post', {}, {});
  // },
  getVisualizationList: async (id) => {
    return request(`${API_URL}/purchase-order-products/calculator/get-pallet-data/${id}`, 'post', {}, {});
  },
  getTotals: async (id) => {
    return request(`${API_URL}/purchase-order-products/calculator/get-totals-data/${id}`, 'post');
  },
  updateCalculator: async (id, values) => {
    const body = JSON.stringify(values);
    return request(`${API_URL}/purchase-order-products/calculator/update/${id}`, 'post', body, {});
  },
  // visualizeGrid: async (id) => {
  //   const body = JSON.stringify({
  //     skip: 0,
  //     take: 50,
  //   });
  //   return request(`${API_URL}/purchase-order-products/calculator/visualize-grid/${id}`, 'post', body);
  // },
  // importOrderProducts: async (fileId: string, orderId: string): Promise<AxiosResponse<OrderProductGetDTO[]>> => {
  //   return request(`${API_URL}/purchase-order-products/import-order-products/${fileId}/${orderId}`, 'post');
  // },
  // getPalletCountForStatuses: async (orderId: string): Promise<AxiosResponse<PalletsPerStatusDto>> => {
  //   return request(`${API_URL}/purchase-order-products/get-pallets-per-status/${orderId}`, 'get');
  // },
  export: async (id: string): Promise<AxiosResponse<any>> => {
    return request(`${API_URL}/purchase-orders/export/${id}`, 'get', null, null, {
      responseType: 'arraybuffer',
    });
  },

  removeCu: async () => {
    return request(`${API_URL}/purchase-order-products/remove-cu`, 'put');
  },
};
